import React, { useState } from "react";
import { MainContainer } from "./styles";
import SelectData from "../../SelectData"
import CustomButton from "../../../general/CustomButton";

const CustomTemplate = ({lists, article, setArticle}) => {
  const [departamento, setDepartamento] = useState('');
  const [categoria, setCategoria] = useState('');
  const [tipo, setTipo] = useState('');
  const [retailer, setRetailer] = useState('');
  const deptosListKeys = Object.keys(lists.depot);
  const catOptions = departamento ? Object.keys(lists.depot[departamento]?.sub_category) : [];
  const typeOptions = categoria ? Object.keys(lists.depot[departamento]?.sub_category[categoria]?.sub_category) : [];
  const retailerOptions = categoria ? Object.keys(lists.depot[departamento]?.sub_category[categoria]?.sub_category) : [];

  const handleSelectChange = (selectedOption, id) => {
    setArticle((prev) => {
      const updatedArticle = { ...prev };
  
      if (id === "depot") {
        updatedArticle.depot = selectedOption;
      } else if (id === "category") {
        updatedArticle.category = selectedOption;
      } else if (id === "type") {
        updatedArticle.type = selectedOption;
      } else if (id === "retailer") {
        updatedArticle.retailer = selectedOption;
      }
  
      if (updatedArticle.depot && updatedArticle.category && updatedArticle.type) {
          const idCategory = lists.depot[departamento]?.sub_category[categoria]?.sub_category[updatedArticle.type]?.id_category;
          updatedArticle.id = idCategory;
      }
      return updatedArticle;
    });
  };
  
  return (
    <MainContainer>
      <div className="indications">
        <h2 className="title">Descargar plantilla</h2>
        <p>Para poder descargar la tu plantilla personalizada debes realizar lo siguiente:</p>
        <p>Elige el departamento, categoría, tipo y cadena, una vez que selecciones todos da clic en el botón generar, en cuanto se genere se descargará automaticamente la plantilla</p>
      </div>
      <div className="selects-container">
        <SelectData
          id="depot"
          placeholder="Elige un Departamento"
          options={deptosListKeys}
          label={article.depot}
          value={departamento}
          onChange={(selectedOption) => {
            setDepartamento(selectedOption);
            setCategoria("");
            setTipo("");
            setRetailer("");
            handleSelectChange(selectedOption, "depot");
          }}
          variant="gray"
        />
        <SelectData
          id="category"
          placeholder="Elige una Categoría"
          options={catOptions}
          label={article.category}
          value={categoria}
          onChange={(selectedOption) => {
            setCategoria(selectedOption);
            setTipo("");
            setRetailer("");
            handleSelectChange(selectedOption, "category");
          }}
          variant="gray"
        />
        <SelectData
          id="type"
          placeholder="Elige un Tipo"
          options={typeOptions}
          label={article.type}
          value={tipo}
          onChange={(selectedOption) => {
            setTipo(selectedOption);
            setRetailer("");
            handleSelectChange(selectedOption, "type");
          }}
          variant="gray"
        />
        <SelectData
          id="retailer"
          placeholder="Elige una cadena"
          options={retailerOptions}
          label={article.retailer}
          value={retailer}
          onChange={(selectedOption) => {
            setRetailer(selectedOption);
            handleSelectChange(selectedOption, "retailer");
          }}
          variant="gray"
        />
        <CustomButton
            variant="white"
            label="Generar plantilla"
            onClick=""
          />
      </div>
      
    </MainContainer>
  );
};

export default CustomTemplate;